module.exports = __webpack_public_path__ + "img/instagram-icon.b0a9f181.svg";